module.exports = __webpack_public_path__ + "static/media/tom-ford-noir-extreme-big.0480ea69.png";